import RestAPI from '../../../Common/restApi';

export default class VehicleGpsTrackingApi {
  static show() {
    return RestAPI.get('/api/v2/organization');
  }

  static devices() {
    return RestAPI.get('/alpha/mojio/devices');
  }
}
